<p-dialog #dialog appendTo="body" header="Enable/Disable Ports" [(visible)]="visible" [modal]="true"
		  [resizable]="true" (onHide)="onHide()" styleClass="port-status-dialog" (onShow)="onShow()"
		  [style]="{'width': '1200px', 'height': '800px', 'min-width': '625px', 'min-height': '670px'}">

	<port-enable-disable-editor [deviceGuid]="deviceGuid" [ifTableHeightVh]="0" [ifTableHeightPx]="ifTableHeightPxProp"
								[ifTableMinHeight]="150" [visible]="visible">
	</port-enable-disable-editor>

	<p-footer>
		<button type="button" pButton icon="fa fa-times" [disabled]="false"
				(click)="onCloseClicked()" label="Close"></button>
	</p-footer>

</p-dialog>
